import React, { FC, useMemo } from 'react';
import { Badge, Heading, Icon, Link, Text, FormControl, FormLabel, Switch } from '@chakra-ui/react';
import { Datasources } from '@adflow/types';
import { LuExternalLink } from 'react-icons/lu';
import { PiSparkle } from 'react-icons/pi';

type DataMappingMagicProps = {
  mappingEnabled: boolean;
  onToggleMapping: (val: boolean) => void;
  suggestedDataSources: Datasources.SuggestedDataSources;
};

const DataMappingMagic: FC<DataMappingMagicProps> = ({
  mappingEnabled,
  onToggleMapping,
  suggestedDataSources,
}) => {
  const dataSourceNames = useMemo(() => {
    return suggestedDataSources.map((ds) => {
      return ds[0].name;
    });
  }, [suggestedDataSources]);

  return (
    <>
      <Heading size="sm">
        Data Mapping <Icon as={PiSparkle} />
      </Heading>
      {suggestedDataSources.length ? (
        <Text mb="0">
          We matched <Badge colorScheme="blue">{suggestedDataSources.length}</Badge> potential data
          sources for your creative -{' '}
          {dataSourceNames.map((v, idx) => (
            <React.Fragment key={v}>
              <Badge colorScheme="blue" textTransform="none">
                {v}
              </Badge>
              {idx === dataSourceNames.length - 1 ? '' : ', '}
            </React.Fragment>
          ))}
          .
        </Text>
      ) : (
        <>
          <Text mb="0">
            We couldn&apos;t find any potential dynamic elements in your creative. Element names
            should follow a{' '}
            <Link
              color="teal.500"
              href="https://marketing-cloud.sportradar.com/support/solutions/articles/77000515734-sportsbooks-integration-manual"
              isExternal
            >
              naming specification <Icon as={LuExternalLink} />
            </Link>{' '}
            to be detected.
          </Text>
        </>
      )}
      <FormControl display="flex" alignItems="center" mt={2}>
        <FormLabel htmlFor="data-mappings" mb="0">
          Create data mappings?
        </FormLabel>
        <Switch
          id="data-mappings"
          colorScheme="teal"
          isChecked={mappingEnabled}
          disabled={suggestedDataSources.length === 0}
          onChange={(evt) => {
            onToggleMapping(evt.target.checked);
          }}
        />
      </FormControl>
    </>
  );
};

export default DataMappingMagic;
